import { I18nContextType } from '../../libs/i18n';

export function formatDate(date) {
  const d = new Date(date);
  //@ts-ignore
  return new Intl.DateTimeFormat('es', { dateStyle: 'long' }).format(d);
}

export const toSeoUrl = (url: string): string => {
  return url
    .normalize('NFD') // Change diacritics
    .replace(/[\u0300-\u036f]/g, '') // Remove illegal characters
    .replace(/\s+/g, '-') // Change whitespace to dashes
    .toLowerCase() // Change to lowercase
    .replace(/&/g, '-and-') // Replace ampersand
    .replace(/[^a-z0-9-]/g, '') // Remove anything that is not a letter, number or dash
    .replace(/-+/g, '-') // Remove duplicate dashes
    .replace(/^-*/, '') // Remove starting dashes
    .replace(/-*$/, ''); // Remove trailing dashes
};

export const capitalizeFirstLetterOfEachWord = (str: string): string => {
  const words = str.split(' ');

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substring(1);
  }

  return words.join(' ');
};

export const split = <T>(array: T[], max_chunk_size: number): T[][] => {
  const [...arr] = array;
  const res = [];
  while (arr.length) {
    res.push(arr.splice(0, max_chunk_size));
  }
  return res;
};

export const distanceInKm = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const rInKm = 6371;
  const dLat = convertDegreesToRadians(lat2 - lat1);
  const dLon = convertDegreesToRadians(lon2 - lon1);
  const auxLat1 = convertDegreesToRadians(lat1);
  const auxLat2 = convertDegreesToRadians(lat2);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) *
      Math.sin(dLon / 2) *
      Math.cos(auxLat1) *
      Math.cos(auxLat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = rInKm * c;
  return d;
};

const convertDegreesToRadians = (value: number): number => {
  return (value * Math.PI) / 180;
};

export const formatCurrency = (value: number, locale: string): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
  })
    .format(value)
    .replace(/\D00(?=\D*$)/, '');
};

export const removeCounty = (text: string): string => {
  return text.replace(/ provincia| county| province/gi, '');
};

const formatForSlider = (
  value: number,
  valueMin: number,
  valueMax: number,
  i18n: I18nContextType,
  formatter: (value: number) => string = (value) => value.toString()
): string => {
  let result = formatter(value);
  if (value === valueMin) {
    result = `${result} ${i18n.t('messages.lessThan')}`;
  } else if (value === valueMax) {
    result = `${result} ${i18n.t('messages.greaterThan')}`;
  }
  return result;
};

export const formatCurrencyForSlider = (
  price: number,
  priceMin: number,
  priceMax: number,
  i18n: I18nContextType,
  abbreviateThousands = false
): string => {
  let result = formatForSlider(price, priceMin, priceMax, i18n, (value) =>
    formatCurrency(value, i18n.activeLocale)
  );

  if (abbreviateThousands && price < 1000000 && price % 1000 === 0) {
    result = result.replaceAll('.000', 'K').replaceAll(',000', 'K');
  }

  return result;
};

export const formatSqrMetersForSlider = (
  sqrMeters: number,
  sqrMetersMin: number,
  sqrMetersMax: number,
  i18n: I18nContextType
): string => {
  return formatForSlider(
    sqrMeters,
    sqrMetersMin,
    sqrMetersMax,
    i18n,
    (value) => `${value}m²`
  );
};
